import { Box } from "@chakra-ui/react";
import { baseColors } from "goi_common/src/design-system";

interface ConsultantIllustrationProps {
  /** 원형 배경의 지름(px). 기본값은 최초 도입처인 견적 준비 화면(/match/recommendation/[id]) 크기 */
  size?: number;
}

/**
 * 상담원 일러스트. 원형 배경 안에서 하단이 잘리도록 설계돼 있어 overflow hidden이 필요하다.
 * /match/recommendation/[id] 견적 준비 화면과 장지 견적 접수 완료 화면이 공유한다.
 */
export const ConsultantIllustration = ({ size = 88 }: ConsultantIllustrationProps) => {
  const scale = size / 88;

  return (
    <Box
      width={`${size}px`}
      height={`${size}px`}
      flexShrink={0}
      borderRadius="50%"
      backgroundColor={baseColors.blue_150}
      overflow="hidden"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <svg
        style={{ marginTop: `${16 * scale}px` }}
        width={size}
        height={76 * scale}
        viewBox="0 0 88 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M48.9582 51.4834H37.791V62.976H48.9582V51.4834Z" fill="#FFCBC2" />
        <path
          d="M77.3724 79.8102C76.1393 67.9922 66.702 60.6959 55.3122 57.8356V57.8013C53.4453 57.2875 51.5955 56.7908 48.9578 56.4482L44.6246 61.4324C43.9566 62.2031 42.7577 62.2202 42.0726 61.4666L37.7907 56.7737C35.153 57.1162 33.3375 57.6129 31.4535 58.1439V58.1781C20.6289 61.2268 11.8424 68.4204 10.6093 79.7931C10.4551 81.2489 11.6369 82.4992 13.0927 82.4992H74.9061C76.3619 82.4992 77.5437 81.2661 77.3896 79.8102H77.3724Z"
          fill="#767A7F"
        />
        <path
          d="M63.0016 32.1356C63.0016 49.3595 55.5682 54.2591 43.1336 54.2591C30.699 54.2591 23.2656 43.897 23.2656 30.7944C23.2656 17.6918 30.7161 7.08984 43.1507 7.08984C55.5853 7.08984 63.0187 16.452 63.0187 29.5375L63.0016 32.1356Z"
          fill="#FFCBC2"
        />
        <path
          d="M37.4989 37.9861C38.3897 37.9861 39.1263 37.1638 39.1263 36.1703C39.1263 35.1767 38.3897 34.3545 37.4989 34.3545C36.6081 34.3545 35.8887 35.1596 35.8887 36.1703C35.8887 37.181 36.6253 37.9861 37.4989 37.9861Z"
          fill="#36383A"
        />
        <path
          d="M49.2489 37.9861C50.1397 37.9861 50.8763 37.1638 50.8763 36.1703C50.8763 35.1767 50.1568 34.3545 49.2489 34.3545C48.341 34.3545 47.6387 35.1596 47.6387 36.1703C47.6387 37.181 48.3581 37.9861 49.2489 37.9861Z"
          fill="#36383A"
        />
        <path
          d="M45.6474 44.7425C45.86 44.4536 46.2684 44.3908 46.5573 44.6034C46.8447 44.8162 46.9044 45.2211 46.6926 45.5095C46.4202 45.8796 45.957 46.2424 45.4105 46.5096C44.8544 46.7814 44.1647 46.9794 43.4103 46.9796C42.6511 46.9796 41.9542 46.7872 41.3914 46.5171C40.8412 46.2531 40.3648 45.8885 40.0942 45.4907C39.8931 45.1942 39.9708 44.79 40.2672 44.5884C40.5637 44.3872 40.9679 44.465 41.1695 44.7613C41.2713 44.9104 41.5329 45.1468 41.9516 45.3478C42.3585 45.5431 42.8659 45.6825 43.4103 45.6825C43.9397 45.6823 44.4373 45.5386 44.8428 45.3403C45.2569 45.1375 45.5322 44.8985 45.6474 44.7425Z"
          fill="#36383A"
        />
        <path
          d="M63.2254 32.6414C62.1635 36.752 47.6394 20.2068 47.6394 20.2068C47.6394 20.2068 24.6199 35.7072 23.5923 32.6414C19.0706 19.1449 29.0388 6.7959 43.4089 6.7959C57.7789 6.7959 66.5139 19.9499 63.2254 32.6414Z"
          fill="#36383A"
        />
        <path
          d="M61.6668 27.6793C61.6668 16.5554 53.7023 9.82003 44 9.81979C34.2977 9.82021 25.5861 16.5557 25.5861 27.6793V39.6556H21.2656V27.6793C21.2656 14.5475 31.5516 5.4997 44 5.49929C56.4485 5.4996 65.8237 14.5476 65.8237 27.6793L65.6939 39.6556H61.3734L61.6668 27.6793Z"
          fill="#767A7F"
        />
        <path
          d="M61.472 40.6834C61.472 39.6383 62.7041 38.7904 63.7491 38.79C64.7945 38.79 65.7438 39.638 65.7438 40.6834C65.7438 47.2754 59.9659 52.6928 53.5406 53.3298C52.5008 53.4329 51.574 52.6741 51.4703 51.6345C51.3673 50.5945 52.1258 49.6677 53.1656 49.5642C57.6739 49.1176 61.472 45.3101 61.472 40.6834Z"
          fill="#767A7F"
        />
        <rect
          x="45.0391"
          y="48.2451"
          width="9.38191"
          height="6.75497"
          rx="3.37749"
          fill="#69A7FF"
        />
        <path
          d="M25.814 24.3418C20.6448 24.3418 16.4609 28.5256 16.4609 33.6948C16.4609 38.864 20.6448 43.0479 25.814 43.0479V24.358V24.3418Z"
          fill="#69A7FF"
        />
        <path
          d="M61.354 24.3418C66.5232 24.3418 70.707 28.5256 70.707 33.6948C70.707 38.8641 66.5232 43.0479 61.354 43.0479V24.358V24.3418Z"
          fill="#69A7FF"
        />
      </svg>
    </Box>
  );
};
